import { useQuery } from '@tanstack/react-query';
import { api } from './client';

export function useProducts() {
  return useQuery({
    queryKey: ['products'],
    queryFn: api.listProducts,
    refetchInterval: 15_000,
  });
}

export function useProduct(id: string | undefined) {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => api.getProduct(id!),
    enabled: !!id,
  });
}

export function useComponents(type?: 'core' | 'addon') {
  return useQuery({
    queryKey: ['components', type ?? 'all'],
    queryFn: () => api.listComponents(type),
  });
}

export function useComponent(id: string | undefined) {
  return useQuery({
    queryKey: ['component', id],
    queryFn: () => api.describeComponent(id!),
    enabled: !!id,
  });
}

export function useDeployment(id: string | undefined, opts?: { poll?: boolean }) {
  return useQuery({
    queryKey: ['deployment', id],
    queryFn: () => api.getDeployment(id!),
    enabled: !!id,
    refetchInterval: (q) => {
      if (!opts?.poll) return false;
      const status = q.state.data?.deployment.status;
      return status === 'pending' || status === 'in_progress' ? 2_000 : false;
    },
  });
}
